//#region src/integrations/openai/openAITypes.ts
const OPENAI_INTEGRATION_ID = "openai";

//#endregion
export { OPENAI_INTEGRATION_ID };
//# sourceMappingURL=openAITypes.js.map